<!-- Score box at the top of the second tab (#seoScoreBox): n/max, the type's heading ("Ready for YouTube?"…), the bar,
     and every check with its message (seoChecks in src/features/seo.ts). Green when every check passes. -->
<script setup lang="ts">
import { computed } from 'vue'
import { seoHead, type SeoCheck } from '../../features/seo'
import type { Kind } from '../../data/types'

const props = defineProps<{ checks: SeoCheck[]; kind: Kind }>()
const n = computed(() => props.checks.filter(c => c.ok).length)
const max = computed(() => props.checks.length)
const full = computed(() => n.value === max.value)
const head = computed(() => seoHead(props.kind)[full.value ? 0 : 1])
</script>

<template>
  <div id="seoScoreBox"><div :class="['rounded-2xl border', full ? 'border-green-400/40 bg-green-400/10' : 'border-gray-800 bg-darkinput/40', 'p-4']">
    <div class="flex items-center gap-3"><span :class="['text-2xl font-black', full ? 'text-green-400' : 'text-gray-100']">{{ n }}/{{ max }}</span>
      <div class="flex-1"><div class="font-bold text-gray-100">{{ head }}</div><div class="w-full bg-gray-800 h-1.5 rounded-full overflow-hidden mt-1.5">
        <!-- Drawn again at every change of the score, like before (no sliding of the bar) -->
        <div :key="n + '/' + max" :class="[full ? 'bg-green-400' : 'bg-brand', 'h-full transition-all']" :style="{ width: n / max * 100 + '%' }"></div></div></div></div>
    <div class="mt-3 grid sm:grid-cols-2 gap-x-4 gap-y-1.5">
      <div v-for="c in checks" :key="c.id" class="flex items-start gap-2 text-[11px]"><i :class="['fas', c.ok ? 'fa-circle-check text-green-400' : 'fa-circle-exclamation text-amber-400', 'mt-0.5']"></i><span><b class="text-gray-200">{{ c.label }}</b> <span class="text-gray-400">{{ c.msg }}</span></span></div>
    </div></div></div>
</template>
